/**
 * Error codes returned in the API envelope's inner payload
 * (`res.data.data.code`). Shared across b2c and backoffice so both can react
 * to the same structured backend errors (e.g. refresh-rates "room no longer
 * available"). Always treat the code as OPTIONAL — older responses and
 * non-hotel providers may omit it.
 */
export enum ErrorCode {
  MISSING_DATA = 'missing_data',
  DEFAULT_ERROR = 'default_error',
  ROOM_NOT_AVAILABLE = 'room_not_available',
}
